import React, { useContext, useEffect, useState, useRef, memo } from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { useTranslation } from 'react-i18next';
import { Context } from '../Context';
import {ReactComponent as IconChevron} from './ApartmentView/assets/icons/icon-chevron.svg';
import styles from '../styles/bim.module.scss';
import CustomTooltip from './ToolTipInfoCustomMUI';
import Zoom from '@mui/material/Zoom';
//media
import BimLogo from './BimLogo';
// import { ReactComponent as DragIcon } from '../media/img/icon-drag.svg';
import { ReactComponent as CompassIcon } from '../media/img/Compas.svg';
import { ReactComponent as HideOverlayIcon } from '../media/img/Hide.svg';
import { ReactComponent as ShowOverlayIcon } from '../media/img/Show.svg';
import { ReactComponent as CloseIcon } from '../media/img/Close.svg';
import { ReactComponent as LeftArrowIcon } from '../media/img/Left.svg';
// import { ReactComponent as ChevronIcon } from './ApartmentView/assets/icons/icon-chevron.svg';
import { ReactComponent as RotateRightIcon } from '../media/img/icon-rotate-right.svg';
import { ReactComponent as RotateLeftIcon } from '../media/img/icon-rotate-left.svg';
import BuildingsLayerIcon from './layerButtons/BuildingsLayerIcon';
import TiersLayerIcon from './layerButtons/TiersLayerIcon';
import ApartmentsLayerIcon from './layerButtons/ApartmentsLayerIcon';
//components
import OverviewLayer from './layers/OverviewLayer';
import ToolTip from './ToolTip';
import Loading from './Loading';

// import { AVAILABILITY_STATUS } from '../constants/availabilityStatus';
import { MODEL_SCOPE } from '../constants/modelScope';
import { LAYER_TYPES } from '../constants/layerTypes';
import { MOBILE_VIEW_TYPES	} from '../constants/mobileViewTypes';

// const { AVAILABLE, SOLD, RESERVED, UNKNOWN } = AVAILABILITY_STATUS;
const { NO_MODEL, SITE, EDIFICE } = MODEL_SCOPE;
const { BUILDINGS_LAYER, TIERS_LAYER, APARTMENTS_LAYER } = LAYER_TYPES;
const { VISUALIZATIONS_VIEW } = MOBILE_VIEW_TYPES;


function ModelView({ setShowView }) {
    const {
    dataUrl,
		projectData,
		isMobile,
		isDesktop,
		loading,
		activeBuilding,
		setActiveBuilding,
		displayableApartmentsData,
		activeApartment,
		activeLayer,
		setActiveLayer,
		setMobileActiveView,
		currentIndex,
		setCurrentIndex,
		currentModelScope, setCurrentModelScope,
		projectSetup,
		updateUrlHash,
		applyFiltersHandler,
		buildingsData,
	} = useContext(Context);

	const [showLayers, setShowLayers] = useState(true);

	const [compassDirection, setCompassDirection] = useState(0);
	const [initialFrame, setInitialFrame] = useState(0);
	const [initialNorthAng, setInitialNorthAng] = useState(0);
	const [isSingleEdifice, setIsSingleEdifice] = useState(false);

	const [propsCompleted, setPropsCompleted] = useState(false);

	const splideRef = useRef();

	const [isDragging, setIsDragging] = useState(false);
	const [startX, setStartX] = useState(0);

	const [scrollingInterval, setScrollingInterval] = useState(null);
	const [tooltipVisible, setTooltipVisible] = useState(false);
	const [tooltipContent, setTooltipContent] = useState({
		tier: '',
		apartments: 0,
	});
	const [imgsLoadingProgress, setImgsLoadingProgress] = useState(0);

	const [isLayerSelectorHovered, setIsLayerSelectorHovered] = useState(false);
	const [whichLayerSelectorHovered, setWhichLayerSelectorHovered] =
		useState(null);
	const [isMobileRotateExpanded, setIsMobileRotateExpanded] = useState(false);

	const imgsLoadingProgressRef = useRef(0);
	const layerSelectorRef = useRef(null);
	const layerLegendRef = useRef(null);

	const { t } = useTranslation();

	const uniqueTypesOfRooms = displayableApartmentsData?.reduce((acc, apartment) => {
		if (apartment.rooms && !acc.includes(apartment.rooms)) {
			acc.push(apartment.rooms);
		}
		return acc;
	}, []) ?? [];

	const hasSiteThreeDRender = projectSetup?.site?.render_360 ?? false;


	const typesOfRoomsAcceding = uniqueTypesOfRooms.sort((a, b) => a - b);

	const framesCount = projectSetup?.site?.render_360_frames ?? 72;
	const moveThreshold = 10;

	const getFontSize = () => {
		if (window.innerWidth <= 992) return 12;
		if (window.innerWidth <= 1366) return 14;
		return 16;
	};

	function goToNorth() {
		if (compassDirection < 180) {
			handleButtonHold(-1, true);
		} else {
			handleButtonHold(1, true);
		}
	}

	function closeHandle() {
		setShowView(0);
		setMobileActiveView(VISUALIZATIONS_VIEW);
		setActiveBuilding(null);
		setCurrentModelScope(NO_MODEL);
		updateUrlHash('visualisation');
	}
	function backHandle() {
		// setActiveBuilding(null);
		setCurrentModelScope(SITE);
	}

	const calculateAngle = (currentImg) => {
		const { address } = projectData;
		const angle = (360 / 72) * currentImg - address.north_ang;
		return angle;
	};

	const moveSlide = (direction, goToNorth = false, intervalId) => {
		const newIndex = (currentIndex + direction + framesCount) % framesCount;
		if (direction === 1) {
			splideRef.current.splide.go('>');
		} else {
			splideRef.current.splide.go('<');
		}
		setCurrentIndex(splideRef.current.splide.index);

		return calculateAngle(splideRef.current.splide.index);
	};

	function isBetweenInCircle(x) {
		x = ((x % 360) + 360) % 360;
		return x >= 358 || x <= 5;
	}

	const handleButtonHold = (direction, goToNorth = false) => {
		if (!scrollingInterval) {
			const intervalId = setInterval(
				() => {
					let rot = moveSlide(direction, goToNorth);
					setCompassDirection(rot);
					if (goToNorth) {
						if (isBetweenInCircle(rot)) {
							clearInterval(intervalId);
							setScrollingInterval(null);
						}
					}
				},
				goToNorth ? 10 : 50
			);
			setScrollingInterval(intervalId);
		}
	};

	const handleButtonRelease = () => {
		if (scrollingInterval) {
			clearInterval(scrollingInterval);
			setScrollingInterval(null);
		}
	};

	const handleMouseDown = (e) => {
		setIsDragging(true);
		setStartX(e.clientX || e.touches[0].clientX);
	};

	const handleMouseUp = () => {
		setIsDragging(false);
	};

	const handleMouseMove = (e) => {
		if (!isDragging) return;
		const clientX = e.clientX || e.touches[0].clientX;
		const deltaX = startX - clientX;

		if (Math.abs(deltaX) < moveThreshold) return;
		const newIndex = Math.floor(deltaX / (window.innerWidth / framesCount));
		const updatedIndex = (currentIndex + newIndex + framesCount) % framesCount;

		if (updatedIndex !== currentIndex) {
			splideRef.current.splide.go(updatedIndex);
			setCurrentIndex(updatedIndex);
			setStartX(clientX);
			setCompassDirection(calculateAngle(currentIndex) ?? 0);
		}
	};

	const preventScroll = (e) => {
		e.preventDefault();
	};

  const getApartmentTypeLabel = (apartment) => {
    if (!apartment?.type) return "";
    const firstLetter = apartment.type[0].toUpperCase();
    if (firstLetter === "M") return t("apartment");
    if (firstLetter === "U") return t("unit");
    if (firstLetter === "B") return t("premises");
    return "";
  }

	// useEffect(() => {
	// 	if (activeApartment) {
	// 		setActiveLayer(2);
	// 		const apartment = displayableApartmentsData.find(
	// 			(apartment) => apartment.id_original == activeApartment
	// 		);

	// 		if (apartment) {
	// 			const apartmentLabel = getApartmentTypeLabel(apartment);
	// 			const title = `${apartmentLabel} - ${apartment.id_original}`;
	// 			const surface = t('surface') + ': ' + apartment.area_original;
	// 			const rooms = t('rooms') + ': ' + apartment.rooms;
	// 			const tier = t('tier') + ': ' + tiersData[apartment.ref_tier ?? 0].name;
	// 			const availability = apartment.availability ?? AVAILABLE;
	// 			if (isMobile) {
	// 				setTooltipContent({
	// 					title: title,
	// 					surface: surface,
	// 					rooms: rooms,
	// 					tier: tier,
  //           btntext: projectSetup.website.are_sold_apartments_accessible ? `${t("see_apartment")} MV-1` : availability === SOLD ? null : `${t("see_apartment")} MV-2`,
	// 					id: apartment.id,
	// 					behavior: 1,
	// 					availability: availability,
	// 				});
	// 				setTooltipVisible(true);
	// 			} else {
	// 				setTooltipVisible(false);
	// 			}
	// 		}
	// 	} else {
	// 		setActiveLayer(2);
	// 	}

	// 	return () => {
	// 		setImgsLoadingProgress(0);
	// 	};
	// }, [loading, projectData, activeBuilding, activeApartment]);
	useEffect(() => {
		return () => {
			setImgsLoadingProgress(0);
		};
	}, [loading, projectData]);

	useEffect(() => {
			imgsLoadingProgressRef.current = 0;
			setImgsLoadingProgress(0);
	}, [currentModelScope]);

	useEffect(() => {
		if (!loading && projectData) {
			// get initial frame from project data
			const initialActiveFrame = projectData?.address?.start_frame ?? 0;

			setInitialFrame(initialActiveFrame);
			if (currentIndex) {
				setCurrentIndex(currentIndex);
			} else {
				setCurrentIndex(initialActiveFrame);
			}

			// get north angle from project data
			const initialCompass = projectData?.address?.north_ang ?? 0;
			setInitialNorthAng(initialCompass);

			//calculate initial compass position

			const initialCompasAngle = calculateAngle(initialActiveFrame);
			setCompassDirection(initialCompasAngle);

			//go to initial frame on splide
			if (splideRef.current) {
				if (currentIndex) {
					splideRef.current.splide.go(currentIndex);
				} else {
					splideRef.current.splide.go(initialActiveFrame);
				}
			}

			//check edifices num
			const edificesCheck = projectData?._edifices?.names ?? [];
			const singleEdifice = edificesCheck.length == 1 ? true : false;

			if (singleEdifice) {
				activeApartment ? setActiveLayer(2) : setActiveLayer(2);
				setIsSingleEdifice(edificesCheck[0].name);
			}
			setPropsCompleted(true);
		}
	}, [loading]);

	useEffect(() => {
		setImgsLoadingProgress(imgsLoadingProgressRef.current);
	}, [imgsLoadingProgress]);

	useEffect(() => {
		const touchMoveHandler = (e) => {
			if (isDragging) {
				preventScroll(e);
			}
		};

		document.addEventListener('touchmove', touchMoveHandler, {
			passive: false,
		});

		return () => {
			document.removeEventListener('touchmove', touchMoveHandler);
		};
	}, [isDragging]);

	const activeBuildingIdCad = buildingsData?.find(edifice => edifice.name_original === activeBuilding)?.id_cad;
	const loadingBackgroundURL = currentModelScope === EDIFICE && activeBuilding //activeBuilding is buildings name_original: A, 1 etc.
		? `${dataUrl}buildings/${activeBuildingIdCad}/render_360/${activeBuildingIdCad}_render_360_${currentIndex.toString().padStart(3, '0')}.jpg`
		: `${dataUrl}site/render_360/${currentIndex.toString().padStart(3, '0')}.jpg`;
  
	const getModelImgURL = (index) => {
	const indexPaddedString = index.toString().padStart(3, '0');
		if (currentModelScope === EDIFICE && activeBuilding) {
			return `${dataUrl}buildings/${activeBuildingIdCad}/render_360/${activeBuildingIdCad}_render_360_${indexPaddedString}.jpg`; //${activeBuildingIdCad}_render_360_001
		}
		return `${dataUrl}site/render_360/site_render_360_${indexPaddedString}.jpg`; //site_render_360_001
	};

	const handleLayerSelectorLeave = (e) => {
		const nextElem = e.relatedTarget || e.toElement;
		if (layerLegendRef.current && layerLegendRef.current.contains(nextElem)) {
			return;
		}
		setIsLayerSelectorHovered(false);
	}

  const isModelViewSection = projectSetup?.website?.sections?.render_360 && (projectSetup?.site?.render_360 ||  projectSetup?.buildings?.render_360);
	if(!isModelViewSection) {
		console.log(
			'%c[ModelView] ModelView section is disabled in project settings',
			'color: orange; font-weight: bold;'
		);
		return null;
	}
	if (loading && isModelViewSection) {
		return <Loading />;
	}
	return (
		!loading &&
		projectData &&
		propsCompleted && (
			<div
				id="model"
				className={styles.model_view}
				onMouseDown={handleMouseDown}
				onMouseUp={handleMouseUp}
				onMouseMove={handleMouseMove}
				onTouchStart={handleMouseDown}
				onTouchMove={handleMouseMove}
				onTouchEnd={handleMouseUp}
			>
				{imgsLoadingProgress !== framesCount && (
					<>
						<Loading 
						progress={`${imgsLoadingProgress}/${framesCount}`}
						// background={loadingBackgroundURL}
						background={getModelImgURL(currentIndex + 1)}
						loadedFrames={imgsLoadingProgress}
						totalFrames={framesCount}
						/>
						<button
							className={styles.model_button}
							onClick={() => closeHandle()}
							style={{
								position: 'absolute',
								top: '1rem',
								right: '2.5rem',
								zIndex: 10000,
							}}
						>
							<CloseIcon
								className={styles.model_button_icon}
								title="Close model"
							/>
						</button>
					</>
				)}
				<Splide
					className={`${styles.model_splide} `}
					style={{
						display: imgsLoadingProgress !== framesCount ? 'none' : 'block',
					}}
					ref={splideRef}
					options={{
						type: 'fade',
						arrows: false,
						pagination: false,
						focus: 'center',
						speed: 0,
						rewind: true,
						start: currentIndex,
					}}
				>
					{Array.from({ length: framesCount }, (_, index) => (
						<SplideSlide key={index}>
							{/* {currentModelScope === EDIFICE && activeBuilding ? (
								<img
									className={styles.model_slide}
									src={`${dataUrl}edifices/${activeBuilding}/${index}.jpg`}
									alt={`Frame ${index}`}
									onLoad={() => {
										if (imgsLoadingProgressRef.current < framesCount) {
											imgsLoadingProgressRef.current += 1;
											setImgsLoadingProgress(imgsLoadingProgressRef.current);
										}
									}}
								/>
							) : (
								<img
									className={styles.model_slide}
									src={`${dataUrl}project/${index}.jpg`}
									alt={`Frame ${index}`}
									onLoad={() => {
										if (imgsLoadingProgressRef.current < framesCount) {
											imgsLoadingProgressRef.current += 1;
											setImgsLoadingProgress(imgsLoadingProgressRef.current);
										}
									}}
								/>
							)} */}
								<img
									className={styles.model_slide}
									src={getModelImgURL(index + 1)}
									alt={`Frame ${index}`}
									onLoad={() => {
										if (imgsLoadingProgressRef.current < framesCount) {
											imgsLoadingProgressRef.current += 1;
											setImgsLoadingProgress(imgsLoadingProgressRef.current);
										}
									}}
								/>
						</SplideSlide>
					))}
				</Splide>

				{!loading &&
					projectData &&
					showLayers &&
					imgsLoadingProgress === framesCount && (
						<OverviewLayer
							activeFrame={currentIndex}
							activeLayer={activeLayer}
							tooltipVisible={tooltipVisible}
							tooltipContent={tooltipContent}
							setTooltipVisible={setTooltipVisible}
							setTooltipContent={setTooltipContent}
							isSingleEdifice={isSingleEdifice}
						/>
					)}

				{tooltipVisible && (
					<ToolTip
						content={tooltipContent}
						setTooltipVisible={setTooltipVisible}
					/>
				)}

				{imgsLoadingProgress === framesCount && (
					<>
						<div className={styles.model_top_bar}>
							<div className={styles.model_buttons_container}>
								<button
									onClick={() => goToNorth()}
									className={styles.model_button}
								>
									<CompassIcon
										className={styles.model_button_icon}
										style={{ transform: `rotate(${compassDirection}deg)` }}
									/>
								</button>
								<button
									onClick={() => setShowLayers((prev) => !prev)}
									className={`${styles.model_button} ${
										!showLayers ? styles.model_button_highlighted : ''
									}`}
								>
									{showLayers ? (
										<ShowOverlayIcon
											className={styles.model_button_icon}
											title="Show Layers"
										/>
									) : (
										<HideOverlayIcon
											className={styles.model_button_icon}
											title="Hide Layers"
										/>
									)}
								</button>
							</div>
							<div className={styles.model_buttons_container}>
								{(currentModelScope === EDIFICE && hasSiteThreeDRender) ? (
									<button
										onClick={() => backHandle()}
										className={styles.model_button}
									>
										<LeftArrowIcon
											className={styles.model_button_icon}
											title="Back to estate"
										/>
									</button>
								) : isDesktop ? (
									<button
										onClick={() => closeHandle()}
										className={styles.model_button}
									>
										<CloseIcon
											className={styles.model_button_icon}
											title="Close model"
										/>
									</button>
								) : null}
							</div>
						</div>
					</>
				)}
				{/* {isMobile && showRotateInstruction && (
                    <div className={styles.select_layer_details}>
                        <div className={styles.select_instruction_container}>
                            <DragIcon class={styles.instruction_icon} />
                            <span style={{display:"inline-block"}}>{t('drag_to_rotate')} </span>
                            <ChevronIcon class={styles.instruction_icon_close} onClick={() => setShowRotateInstruction(false)} />
                        </div>
                    </div>
                )} */}
				{isDesktop && (
					<div className={styles.model_bottom_bar}>
						<div>
							<BimLogo />
						</div>
						<div
							className={styles.model_rotate_container}
						>
							<button
								className={`${styles.model_button} ${styles.model_button_small}`}
								onMouseDown={() => handleButtonHold(-1)}
								onMouseUp={handleButtonRelease}
								onMouseLeave={handleButtonRelease}
								onTouchStart={() => handleButtonHold(-1)}
								onTouchEnd={handleButtonRelease}
							>
								<RotateLeftIcon
									className={styles.model_button_icon}
									title={t('rotate_left')}
								/>
							</button>
							<div
								className={styles.model_rotate_label}
							>
								{
									( buildingsData.length === 1 || currentModelScope !== EDIFICE) 
										? t('rotate_around')
										: `${t('building')} ${activeBuilding}`
								}
							</div>
							<button
								className={styles.model_button_small}
								onMouseDown={() => handleButtonHold(1)}
								onMouseUp={handleButtonRelease}
								onMouseLeave={handleButtonRelease}
								onTouchStart={() => handleButtonHold(1)}
								onTouchEnd={handleButtonRelease}
							>
								<RotateRightIcon
									className={styles.model_button_icon}
									title={t('rotate_right')}
								/>
							</button>
						</div>
						<div
							className={styles.model_select_layer_box}
							// onMouseEnter={() => setIsLayerSelectorHovered(true)}
							// onMouseLeave={() => setIsLayerSelectorHovered(false)}
						>
							{ activeLayer === APARTMENTS_LAYER && (
								<CustomTooltip 
									title={t('model_rooms_legend_info')}
									slots={{
										transition: Zoom,
									}}
									arrow
									placement="top"
								>
								<div 
								ref={layerLegendRef}
								className={styles.model_layer_legend}
								onMouseLeave={() => {

								}
								}>
									<span style={{ display: 'inline-block'}}>
										{t('rooms')}:
									</span>
									{typesOfRoomsAcceding.map((type, index) => (
										<svg 
											key={index} 
											xmlns="http://www.w3.org/2000/svg" 
											width={`${getFontSize() * 1.2}px`} 
											height={`${getFontSize() * 1.2}px`} 
											viewBox={`0 0 ${getFontSize() * 1.2} ${getFontSize() * 1.2}`} 
											style={{cursor: 'pointer' }}
											onClick={() => applyFiltersHandler({ ['rooms']: [type, type] })}
										>
											<rect width={`${getFontSize() * 1.2}px`} height={`${getFontSize() * 1.2}px`} data-rooms={type} className='rooms-color'/>
											<text
												x={`${getFontSize() * 0.6}px`}
												y={`${getFontSize() * 0.7}px`}
												textAnchor="middle"
												dominantBaseline="middle"
												fill="var(--color-labels)"
												style={{ fontSize: '1rem', fontWeight: 'bold' }}
												>{type}</text>
										</svg>
									))}
								</div>
								</CustomTooltip>
							)}
						<div
							ref={layerSelectorRef}
							className={styles.model_select_layer_container}
							onMouseEnter={() => setIsLayerSelectorHovered(true)}
							// onMouseLeave={() => setIsLayerSelectorHovered(false)}
							onMouseLeave={(e) => handleLayerSelectorLeave(e)}
						>
							{isLayerSelectorHovered && (
								<div
									className={styles.model_buttons_container}
									style={{ width: '100%' }}
								>
									{currentModelScope === SITE && !isSingleEdifice && (
										<button
											className={`${styles.model_button} ${
												activeLayer === BUILDINGS_LAYER ? styles.model_button_highlighted : ''
											}`}
											onClick={(e) => {
												e.stopPropagation();
												setActiveLayer(BUILDINGS_LAYER);
												setShowLayers(true);
											}}
											onMouseEnter={() => setWhichLayerSelectorHovered(0)}
											onMouseLeave={() => setWhichLayerSelectorHovered(null)}
											title={t('buildings')}
										>
											<BuildingsLayerIcon
												className={styles.model_button_icon}
												title={t('buildings')}
											/>
										</button>
									)}
									<button
										className={`${styles.model_button} ${
											activeLayer === TIERS_LAYER ? styles.model_button_highlighted : ''
										}`}
										onClick={(e) => {
											e.stopPropagation();
											setActiveLayer(TIERS_LAYER);
											setShowLayers(true);
										}}
										onMouseEnter={() => setWhichLayerSelectorHovered(1)}
										onMouseLeave={() => setWhichLayerSelectorHovered(null)}
										title={t('tiers')}
									>
										<TiersLayerIcon
											className={styles.model_button_icon}
											title={t('tiers')}
										/>
									</button>
									<button
										className={`${styles.model_button} ${
											activeLayer === APARTMENTS_LAYER ? styles.model_button_highlighted : ''
										}`}
										onClick={(e) => {
											e.stopPropagation();
											setActiveLayer(APARTMENTS_LAYER);
											setShowLayers(true);
										}}
										onMouseEnter={() => setWhichLayerSelectorHovered(2)}
										onMouseLeave={() => setWhichLayerSelectorHovered(null)}
										title={t('apartments')}
									>
										<ApartmentsLayerIcon
											className={styles.model_button_icon}
											title={t('apartments')}
										/>
									</button>
								</div>
							)}
							<div className={`${styles.model_select_layer_label} ${
											isLayerSelectorHovered ? styles.model_select_layer_label_highlighted : ''
										}`}>
								{whichLayerSelectorHovered === null && (
									<span>
                    {activeLayer === BUILDINGS_LAYER && 
											currentModelScope === SITE
                        ? t('select_building')
                        : activeLayer === TIERS_LAYER
													? t('select_tier')
													: activeLayer === APARTMENTS_LAYER
														? t('select_apartment')
														: t('select_layer')
										}
									</span>
								)}
								{whichLayerSelectorHovered !== null && (
									<span>
										{whichLayerSelectorHovered === 0 
											? t('select_building')
											: whichLayerSelectorHovered === 1 
												? t('select_tier')
												: whichLayerSelectorHovered === 2 
													? t('select_apartment')
													: t('select_layer')
										}
									</span>
								)}
								<IconChevron
									className={styles.plan_button_icon_small}
									style={{
										marginLeft: '0.5rem',
										transform: isLayerSelectorHovered
											? 'rotate(90deg)'
											: 'rotate(-90deg)',
										transition: 'transform 0.5s ease',
									}}
								/>
							</div>
						</div>
						</div>
					</div>
				)}

				{isMobile && (
					<>
						<div className={styles.model_mobile_bottom_bar}>
							<div
								className={styles.model_mobile_rotate_container}
								onClick={() => setIsMobileRotateExpanded((prev) => !prev)}
							>
								{isMobileRotateExpanded && (
									<div
										className={styles.model_buttons_container}
										style={{ width: '100%' }}
									>
										<button
											className={styles.model_button}
											onTouchStart={() => handleButtonHold(-1)}
											onTouchEnd={handleButtonRelease}
											onContextMenu={(e) => e.preventDefault()}
											>
												<RotateLeftIcon
													className={styles.model_button_icon}
													title={t('rotate_left')}
												/>
										</button>
										<button
											className={styles.model_button}
											onTouchStart={() => handleButtonHold(1)}
											onTouchEnd={handleButtonRelease}
											onContextMenu={(e) => e.preventDefault()}
										>
											<RotateRightIcon
												className={styles.model_button_icon}
												title={t('rotate_right')}
											/>
										</button>
									</div>
								)}
								<div 
									className={
										`${styles.model_mobile_buttons_label} ${
											isMobileRotateExpanded ? styles.model_mobile_buttons_label_highlighted : ''
										}`
									}>
										<span>{t('rotate_around')}</span>
										<IconChevron
											className={styles.plan_button_icon_small}
											style={{
												marginLeft: '0.25rem',
												transform: isMobileRotateExpanded
													? 'rotate(90deg)'
													: 'rotate(-90deg)',
												transition: 'transform 0.5s ease',
											}}
										/>
								</div>
							</div>
							<div
								className={styles.model_select_layer_container}
								onClick={() => setIsLayerSelectorHovered((prev) => !prev)}
							>
								{isLayerSelectorHovered && (
									<div
										className={styles.model_buttons_container}
										style={{ width: '100%' }}
									>
										{currentModelScope === SITE && !isSingleEdifice && (
											<button
												className={
													`${styles.model_button} ${
													activeLayer === BUILDINGS_LAYER 
														? styles.model_button_highlighted 
														: ''
													}`
												}
												onClick={(e) => {
													e.stopPropagation();
													setActiveLayer(BUILDINGS_LAYER);
													setShowLayers(true);
													setWhichLayerSelectorHovered(0)
												}}
												title={t('buildings')}
											>
												<BuildingsLayerIcon
													className={styles.model_button_icon}
													title={t('buildings')}
												/>
											</button>
										)}
										<button
											className={`${styles.model_button} ${
												activeLayer === TIERS_LAYER ? styles.model_button_highlighted : ''
											}`}
											onClick={(e) => {
												e.stopPropagation();
												setActiveLayer(TIERS_LAYER);
												setShowLayers(true);
												setWhichLayerSelectorHovered(1);
											}}
											title={t('tiers')}
										>
											<TiersLayerIcon
												className={styles.model_button_icon}
												title={t('tiers')}
											/>
										</button>
										<button
											className={`${styles.model_button} ${
												activeLayer === APARTMENTS_LAYER ? styles.model_button_highlighted : ''
											}`}
											onClick={(e) => {
												e.stopPropagation();
												setActiveLayer(APARTMENTS_LAYER);
												setShowLayers(true);
												setWhichLayerSelectorHovered(2);
											}}
											title={t('apartments')}
										>
											<ApartmentsLayerIcon
												className={styles.model_button_icon}
												title={t('apartments')}
											/>
										</button>
									</div>
								)}
								<div 
									className={
										`${styles.model_mobile_buttons_label} ${
											isLayerSelectorHovered ? styles.model_mobile_buttons_label_highlighted : ''
										}`
									}>
									<span>
                    {activeLayer === BUILDINGS_LAYER && 
											currentModelScope === SITE
                        ? t('select_building')
                        : activeLayer === TIERS_LAYER
													? t('select_tier')
													: activeLayer === APARTMENTS_LAYER
														? t('select_apartment')
														: t('select_layer')
											}
									</span>
									<IconChevron
										className={styles.plan_button_icon_small}
										style={{
											marginLeft: '0.25rem',
											transform: isLayerSelectorHovered
												? 'rotate(90deg)'
												: 'rotate(-90deg)',
											transition: 'transform 0.5s ease',
										}}
									/>
								</div>
							</div>
						</div>
						<BimLogo />
					</>
				)}
			</div>
		)
	);
}

export default memo(ModelView);
